settings_module = settings_module or {}
settings_module.basic = (sortable_href, del_href, lang)->
    csfr_key = 'csrfmiddlewaretoken'
    csfr_val = $("input[name=#{csfr_key}]").val()

    Gettext._locale_data = {}
    gt.try_load_lang_po('/static/frontend_bat/app-backbone/locale/' + LOCALE_LOOKUP.gettext[lang] + '/messages.po')

    tabHandler('#personal-tab')
    multiSubmitHandler('form')

    if not Modernizr.touch # na touch zarizenich to musime poresit jinak
        $('.sort .ordering').html('<a class="btn btn-default sort-widget"><span class="icon-move icon-large"></span></a>')
        # trideni
        $('.sort').sortable(
            cursor: 'move'
            axis:   'y'
            update: (e, ui)->
                $row = ui.item
                $tbody = $(this)
                icon = $row.find('.icon-move')

                $tbody.sortable("refresh", { revert: true })
                sorted = $(this).sortable("toArray")
                sorted = _.map(sorted, (i)-> _.last(i.split('_')))
                data = {'order': sorted.join(',')}
                data[csfr_key] = csfr_val
                $tbody.sortable("disable") # dokud nedobehne ajax, nedovolim menit poradi
                icon.toggleClass("icon-move inline-spinner") # roztocim spinner
                $.ajax
                    type:   'POST'
                    url:    sortable_href
                    data:   data
                    success: (msg)->
                        onceAnimate($row,"sort-success")
                    error: ()->
                        onceAnimate($row,"sort-cancel")
                        $tbody.sortable( "cancel" )
                    complete: ()->
                        icon.toggleClass("icon-move inline-spinner") # at to dopadlo jakkoliv vratim ikonu zpatky
                        $tbody.sortable("enable") # a dovolim znovu radit zaznamy
        ).disableSelection()

    # obsluha pro mazani widgetu z tabulky
    $('.sort .remove-widget').click (e) ->
        e.preventDefault()
        $tr = $(@).closest('tr')
        action = gettext("Delete widget?")
        widget_name = $tr.find('td:first').text()
        if confirm("#{action} (#{widget_name})")
            id = $tr.attr('id')
            id = _.last(id.split('_'))
            href = _.initial(del_href.split('/'))
            href.push(id)
            href = href.join('/')
            data = {}
            data[csfr_key] = csfr_val
            $.ajax
                type:   'POST'
                url:    href
                data:   data
                success: (msg)->
                    $tr.addClass("item-removed")
                    if Modernizr.cssanimations
                        $tr.one 'webkitAnimationEnd oanimationend oAnimationEnd msAnimationEnd MSAnimationEnd animationend', () ->
                            $tr.empty().remove()
                    else
                        $tr.empty().remove()
                error: ()->
                    onceAnimate($tr,"item-refused")

    $(".settings table.table tbody td").each (index, value)->
        w = $(value).width()
        $(value).css("width", w)
